<template>
  <div v-if="!is_3pl && !is_delivery_customization" class="container">
    <div class="div">
      <img v-if="loading" :src="imgurl + 'images/pargo_spinner.png'" alt="" class="pargoLoader rotate" />
    </div>

    <div v-show="deliveryServiceType == 'w2p' && !loading" id="pargoContent" class="content-box">
      <div class="flex-container">
        <div class="flex-item">
          <img :src="imgurl + 'images/pargo_logo_circle.svg'" class="pargo-logo" height="75" width="75" />
        </div>
        <div class="flex-item">
          <h6 class="pargo-heading" v-html="orderTimedOut || userChoosePup ? 'Your Chosen Pargo Pickup Point' : 'Please confirm your Pargo Pickup Point'"></h6>
        </div>
      </div>

      <div class="map-container">
        <iframe v-if="!orderTimedOut && !userChoosePup" :height="iframeData.height" :src="iframeData.url" allow="geolocation" class="iframe-style" />
      </div>

      <section v-if="(orderTimedOut || userChoosePup) && !loading">
        <pup-list :closest-pups="selectedPup"></pup-list>
      </section>

      <div id="pargoContainer">
        <div class="align-right">
          <button v-if="!orderTimedOut && userChoosePup && !loading" class="secondary" @click="toggleMap()">Select different pickup point</button>
        </div>
      </div>
    </div>

    <div v-if="deliveryServiceType == 'w2d'">
      <div class="flex-container">
        <div class="flex-item">
          <img :src="imgurl + 'images/pargo_logo_circle.svg'" height="100" width="175" />
        </div>
        <div class="flex-item">
          <h6 class="pargo-heading" v-html="iframeData.title"></h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PuPList from './components/PuPList.vue'
import $ from 'jquery'
import axios from 'axios'

export default {
  components: {
    'pup-list': PuPList
  },
  async mounted () {
    this.imgurl = process.env.APP_URL
    if (process.env.APP_ENV === 'production') {
      this.shopifyAppProxyEnabled = true
    } else if (process.env.APP_ENV === 'local') {
      this.proxyURL = 'dev-proxy'
    } else {
      this.shopifyAppProxyEnabled = true
    }
    this.server_url = process.env.APP_URL
    if (this.shopifyAppProxyEnabled) {
      this.server_url = `${window.location.origin}/tools/${this.proxyURL}/`
    }

    await this.checkSelectedPickupPoint(true)
    this.checkOrderTimedOut()

    this.initCall()
    this.setEventListeners()

    let checkIfOrderTimedOutInterval = setInterval(async () => {
      if (this.checkOrderTimedOut()) {
        await this.checkSelectedPickupPoint()
        clearInterval(checkIfOrderTimedOutInterval)
      }
    }, 30000)
  },
  data () {
    return {
      timed_out: false,
      selectedPup: [],
      iframeData: [],
      loading: true,
      orderDataRetryTimeout: null,
      shopifyAppProxyEnabled: true,
      server_url: '',
      imgurl: null,
      proxyURL: 'proxy',
      orderTimeoutDuration: process.env.MYPARGO_API_SUBMIT_TIMEOUT,
      is_3pl: false,
      is_delivery_customization: false,
      userChoosePup: false,
      orderTimedOut: false
    }
  },
  computed: {
    orderTimeoutMessage () {
      return `Order placed more than ` + this.orderTimeoutDuration + ` minutes ago, unable to select pickup point`
    },
    deliveryServiceType () {
      if (this.iframeData.order) {
        return this.iframeData.order.delivery_service_type
      }
    }
  },
  watch: {
    is_3pl (newVal, oldVal) {
      this.log(`is_3pl changed from ${oldVal} to ${newVal}`)
    },
    is_delivery_customization (newVal, oldVal) {
      this.log(`is_delivery_customization changed from ${oldVal} to ${newVal}`)
    }
  },
  methods: {
    checkOrderTimedOut () {
      let now = new Date()
      let orderCreatedAt = new Date(Shopify.checkout.created_at)
      let orderTimeoutAt = new Date(orderCreatedAt.setMinutes(orderCreatedAt.getMinutes() + parseInt(this.orderTimeoutDuration)))
      this.orderTimedOut = now > orderTimeoutAt

      return this.orderTimedOut
    },
    async checkSelectedPickupPoint (initialCall = false) {
      return await axios
        .post(`${this.server_url}api/order/selected-pup`, {
          order_id: window.Shopify.checkout.order_id,
          customer_id: window['Shopify'].checkout.customer_id,
          host: window.Shopify.shop
        })
        .then(response => {
          if (response.data.is_3pl) {
            this.is_3pl = Boolean(response.data.is_3pl)
          }
          if (response.data.is_delivery_customization) {
            this.is_delivery_customization = Boolean(response.data.is_delivery_customization)
          }
          if (response.data.status === true) {
            this.selectedPup = [response.data.pup]
            if (initialCall) {
              this.userChoosePup = true
            }
          }
        })
    },
    log (msg) {
      console.info(msg)
    },
    initCall () {
      this.orderDataRetryTimeout = setInterval(() => {
        axios
          .post(`${this.server_url}plugin-assets/content`, {
            host: window.Shopify.shop,
            order_id: window.Shopify.checkout.order_id,
            customer_id: window['Shopify'].checkout.customer_id
          })
          .then(response => {
            const data = response.data
            const isStatusFalse = data.status === false
            const isStatusFailed = data.status === 'failed'

            if (isStatusFalse || isStatusFailed) {
              return
            }
            clearInterval(this.orderDataRetryTimeout)
            this.iframeData = data
            this.timed_out = data.timed_out
            if (data.order.delivery_service_type === 'w2d') {
              this.loading = false
              return
            }
            if (data.order.is_3pl) {
              this.is_3pl = true
              return
            }
            if (data.order.is_delivery_customization) {
              this.is_delivery_customization = true
              return
            }
            if (data.order.shopify_plus) {
              this.loading = false
              return
            }
            $('address').first().html(data.formatted_address)
            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
      }, 3000)
      //To investigate further
      // if (window['Shopify'].checkout?.shipping_rate?.title.includes('Select (other) Pargo Point after payment.')) {
      //   this.loading = false
      // }
    },
    toggleMap () {
      if (!this.checkOrderTimedOut()) {
        this.userChoosePup = false
      }
    },
    selectPargoPointFromMap (item) {
      if (item.data.pargoPointCode) {
        this.userChoosePup = true
        this.submitPargoPoint(item.data)
      }
    },
    submitPargoPoint (data) {
      if (this.checkOrderTimedOut()) {
        this.orderTimedOut = true
        alert(this.orderTimeoutMessage)
      } else {
        this.loading = true

        const item = {
          data: data
        }
        item.data.shop = this.iframeData.merchant.name
        item.data.order_id = window.Shopify.checkout.order_id
        item.data.selected_by_user = true

        axios
          .post(`${this.server_url}api/select-pup/${item.data.order_id}/?shop=${item.data.shop}&pargoPointCode=${item.data.pargoPointCode}`, JSON.stringify(item.data), {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(response => {
            const data = response.data
            this.selectedPup = data.data
            this.loading = false
            this.showMap = false
            this.timed_out = data.timed_out

            $('address').first().html(data.formatted_address)
          })
          .catch(error => {
            this.loading = false
          })
      }
    },
    setEventListeners () {
      if (window.addEventListener) {
        window.addEventListener('message', this.selectPargoPointFromMap, false)
      } else {
        window.attachEvent('onmessage', this.selectPargoPointFromMap)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/styles/uptown';
</style>

<style lang="css" scoped>
.pargo-logo {
  /* padding: 10px 2px 10px 17px; */
  padding: 12px 2px 10px 31px;
  margin: 5px 5px 5px 5px;
}

.flex-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-container {
  display: flex;
  flex-direction: row;
}

.pargo-heading {
  font-size: 15px;
  margin: 10px;
  text-transform: initial !important;
}

.rotate {
  animation: rotation 8s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(359deg);
  }
  to {
    transform: rotate(0deg);
  }
}

.iframe-style {
  top: 0;
  left: 0;
  width: 100%;
  border: 0;
}

.pargoLoader {
  opacity: 0.4;
  width: 120px;
  height: 120px;
  animation: rotation 3s infinite linear;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

#pargoPointDropdown {
  display: none;
  flex-direction: row;
}

#pargoPointDropdownContainer {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  flex: 1;
}

#pargo_map_inner {
  width: 422px;
  max-width: 100%;
  border-radius: 38px;
  color: #000;
  font-family: Arial, Helvetica, sans-serif;
  display: block;
  margin: 0 auto;
  font-size: 22px;
  position: relative;
}

#pargoPickupApp {
  position: absolute;
  width: auto;
  height: auto;
  display: block;
  border: 1px solid #ccc;
  top: -16px;
  left: -30px;
  padding: 0;
}

#pargoPickupApp {
  display: block;
  content: ' ';
  background-color: transparent;
  width: 15px;
  height: 13px;
  position: relative;
  top: 0px;
  left: 0px;
}

#pargoPickupApp {
  top: -24px;
}

#pargoContent {
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  min-height: fit-content;
}

#pargoContainer {
  margin: 10px;
}

.pargo_list {
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
}

#pargo_map {
  position: relative;
  height: 580px;
  display: none;
}

#pargo_map {
  width: 100%;
  border-radius: 5px;
}

#pargo_map_inner {
  width: 100%;
  height: 100%;
  border-radius: 30px;
}

.pargo_pup {
  display: flex;
  flex: 1;
  padding-bottom: 8px;
  padding-top: 8px;
}

.pargo_pup_radio_container {
  width: 32px;
  position: relative;
}

.pargoKmContainer {
  margin-left: auto;
  margin-top: auto;
  min-width: 80px;
  text-align: right;
}

.radioPup {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.radioPupCheckmark {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 16px;
  width: 16px;
  border-radius: 4px;
  background-color: #eee;
}

.pargo_pup_radio_container:hover input ~ .radioPupCheckmark {
  background-color: #ccc;
}

.pargo_pup_radio_container input:checked ~ .radioPupCheckmark {
  background-color: white;
  -webkit-box-shadow: inset 0 0 4px #ccc;
  box-shadow: inset 0 0 4px #ccc;
}

.radioPupCheckmark:after {
  content: '';
  position: absolute;
  display: none;
}

.pargo_pup_radio_container input:checked ~ .radioPupCheckmark:after {
  display: block;
}

.pargo_pup_radio_container .radioPupCheckmark:after {
  left: 5.5px;
  top: 3px;
  width: 3.5px;
  height: 7px;
  border: solid blue;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.pargoButtonsContainer {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  padding-bottom: 16px;
  padding-top: 16px;
  margin-left: 8px;
  margin-right: 8px;
  border-top: #d9d9d9 solid 1px;
}

.pargoButton {
  color: #197bbd;
  margin-left: 24px;
  margin-right: 24px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.pargoFullButton {
  border-radius: 12px;
  background: #197bbd;
  color: white;
  padding-right: 16px;
  padding-left: 16px;
}

#pargoSubmitButton {
  display: none;
}

#thePargoPageFrameID {
  display: block;
}

#pargoPickupApp {
  margin: 5px 0 0 auto;
  width: 450px;
  max-width: 100%;
}

.pargo_btn_map {
  margin-top: 20px;
  background: #fff;
  color: #000;
  position: relative;
  border: 1px solid #e8e9eb;
  padding: 10px 15px;
  text-transform: uppercase;
  font-weight: normal;
}

.pargo_btn_map:hover {
  background: #fff200;
  border: 1px solid #fff200;
}
</style>
